import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import { AppErrorFallback } from './components/ErrorFallback';
import { LocaleProvider } from './i18n/LocaleProvider';
import { ApiError } from './lib/apiClient';
import { ThemeProvider } from './theme/ThemeProvider';
import './index.css';

/**
 * Uygulama kökü.
 * Prototipte yalnızca `<StrictMode><App /></StrictMode>` vardı: hata sınırı yok,
 * sunucu state yönetimi yok, bir render hatasında beyaz ekran.
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      /* 4xx yeniden denenmez: 401/403/404/409 sunucunun kesin cevabıdır,
         tekrar sormak yalnızca gecikme ve gereksiz yük üretir. */
      retry: (failureCount, error) =>
        error instanceof ApiError ? error.isRetryable && failureCount < 2 : failureCount < 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      // Yazma işlemleri otomatik tekrarlanmaz. Sunucudaki idempotency anahtarı
      // koruma sağlasa da, tekrar kararını kullanıcıya bırakmak doğrusudur.
      retry: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root elementi bulunamadı');

createRoot(rootElement).render(
  <StrictMode>
    {/* Dil sağlayıcı hata sınırının DIŞINDA: hata ekranının kendisi de
        çevrilebilir olmalı, aksi hâlde en kötü anda dil değişirdi. */}
    <LocaleProvider>
      {/* Tema sağlayıcı da hata sınırının DIŞINDA ve aynı sebeple: hata
          ekranı, kullanıcının seçtiği temada görünmeli. Bir çökme anında
          ekranın aniden bembeyaz olması, hatanın kendisine ek bir şok ekler. */}
      <ThemeProvider>
        <ErrorBoundary FallbackComponent={AppErrorFallback}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </LocaleProvider>
  </StrictMode>,
);
